export const reviewerAdminPaths = [
  "/admin/reports/timespent",
  "/admin/reports/bin",
  "/admin/reports/writeOff",
  "/admin/reports/invoice",
  "/admin/events",
];
export const hasReviewerAdminAccess = (user) =>
  user?.role === "employee" && user.adminAccess === true;
export const getPortalCompanyId = (user) =>
  user?.role === "employee" ? user.company : user?._id;
